import {
  $cameraAngleToOrigin,
  CAMERA_ANGLE_MAX,
  CAMERA_ANGLE_MIN,
  CAMERA_ANGLE_STEP,
  setCameraAngleToOrigin,
} from '@/stores/settingsStore';
import { useStore } from '@nanostores/react';

export function SettingsPanel() {
  const cameraAngle = useStore($cameraAngleToOrigin);

  return (
    <aside className="absolute right-4 bottom-4 z-10 w-56 rounded-xl border border-white/20 bg-[#08111fcc] p-3 backdrop-blur-sm">
      <p className="mb-2 text-xs tracking-[0.12em] text-white/80 uppercase">
        Settings
      </p>
      <label
        className="mb-2 block text-xs text-white/80"
        htmlFor="camera-angle"
      >
        Camera angle: {cameraAngle.toFixed(1)}&deg;
      </label>
      <input
        id="camera-angle"
        type="range"
        min={CAMERA_ANGLE_MIN}
        max={CAMERA_ANGLE_MAX}
        step={CAMERA_ANGLE_STEP}
        value={cameraAngle}
        onChange={event => setCameraAngleToOrigin(Number(event.target.value))}
        className="w-full accent-[#6cc3e0]"
      />
    </aside>
  );
}
